import styled from '@emotion/styled/macro';
import vars from '@variables';

export const StyledMarkdownContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${vars.spacingL};

  p,
  ul > li,
  ol > li,
  quote > p {
    ${vars.fontSize7};
    margin-bottom: ${vars.spacingM};
    line-height: 1.2;
    letter-spacing: -0.04em;
    font-weight: 500;
    color: inherit;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: ${vars.spacingL} 0 ${vars.spacingS};
    color: inherit;
  }

  h2 {
    ${vars.fontSize8}
  }
  h3 {
    ${vars.fontSize6}
  }
  h4 {
    ${vars.fontSize5}
  }

  ul,
  ol {
    margin: ${vars.spacingM} 0;
    padding-left: ${vars.spacingL};

    li {
      margin-bottom: ${vars.spacingXs};
      &::marker {
        color: inherit;
      }
    }
  }

  blockquote {
    margin: ${vars.spacingS} 0 ${vars.spacingM} 0;
    position: relative;

    &::before {
      content: '\\201C';
      ${vars.fontSize10}
      position: absolute;
    }

    p {
      padding: 0 0 ${vars.spacingS} ${vars.spacingXl};
      font-style: italic;
      &:first-of-type {
        padding-top: 1rem;
      }
    }
  }

  a {
    text-decoration: none;
    border-bottom: 1px solid currentColor;
    transition: all ${vars.defaultTransitionDuration} ease;
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: 700;
  }

  hr {
    border: none;
    border-top: 1px solid ${vars.greyHavens};
    margin: ${vars.spacingL} 0;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    margin: ${vars.spacingM} 0;
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: repeat(4, 1fr);

  @media screen and (min-width: ${vars.breakPointTablet}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: repeat(8, 1fr);
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: repeat(12, 1fr);
  }

  ${StyledMarkdownContainer} {
    grid-column: 1 / -1;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: 2 / 8;
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      grid-column: 3 / 11;
    }
  }
`;
